export default class Session {
  /**
   * Initializes the Session data.  For now, we simply delegate to the legacy implementation.
   * This is a first step towards taking over responsibility of the session information
   * within the ES6 code-base.
   *
   * @returns {Promise}
   */
  static init() {
    return window.merchantos.session.init();
  }

  /**
   * Retrieves the logged-in user ID.
   *
   * @returns {number}
   */
  static userID() {
    return window.merchantos.session.getSystemUserID();
  }

  /**
   * Retrieves the account ID of the logged-in user.
   *
   * @returns {number}
   */
  static accountID() {
    return window.merchantos.session.getSystemCustomerID();
  }

  /**
   * Retrieves the employee ID of the logged-in user.
   *
   * @returns {number}
   */
  static employeeID() {
    return window.merchantos.session.getEmployee().employeeID;
  }

  /**
   * Retrieves the session Data as an object
   *
   * @returns {object}
   */
  static sessionData() {
    return window.merchantos.session.sessData;
  }
}
